module.exports = __webpack_public_path__ + "static/media/CS2 -- Persona1.901f8ce0.jpg";